import padCharsStart from 'lodash/fp/padCharsStart';
import { differenceInHours, differenceInMinutes, subHours } from 'date-fns';

const padNumber = padCharsStart('0')(2);

const formatCalendarDuration = (endDate, startDate) => {
  const hours = differenceInHours(endDate, startDate);
  const minutes = differenceInMinutes(subHours(endDate, hours), startDate);
  return `${padNumber(hours)}:${padNumber(minutes)}`;
};

export default formatCalendarDuration;
